var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #2a4265;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_1-3);\n      }\n\n      .cls-2 {\n        stroke: #2a4265;\n        stroke-width: 37px;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_1-2);\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch_1);\n        stroke-width: 27px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 24.79,
    y1: 547.33,
    x2: 1048.88,
    y2: 547.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    "data-name": "New Gradient Swatch 1",
    x1: 367.42,
    y1: 564.67,
    x2: 625,
    y2: 564.67,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    "data-name": "New Gradient Swatch 1",
    x1: 209,
    y1: 640.22,
    x2: 377.89,
    y2: 640.22,
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 536.83,
    cy: 547.33,
    r: 451
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 536.83,
    cy: 547.33,
    r: 498.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m717.35,255h-298.16c-23.34,0-42.51,18.16-44.14,41.1h30.54c1.44-6.18,6.99-10.81,13.6-10.81h298.16c7.71,0,13.98,6.27,13.98,13.98v427.77c0,7.63-6.15,13.84-13.75,13.97v30.29c24.3-.13,44.04-19.93,44.04-44.26v-427.77c0-24.41-19.86-44.27-44.27-44.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m363.43,307.9h298.09c24.43,0,44.27,19.84,44.27,44.27v427.79c0,24.43-19.83,44.27-44.27,44.27h-298.09c-24.43,0-44.27-19.84-44.27-44.27v-427.79c0-24.43,19.84-44.27,44.27-44.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.43,338.18h298.09c7.72,0,13.98,6.26,13.98,13.98v427.79c0,7.72-6.26,13.98-13.98,13.98h-298.09c-7.72,0-13.98-6.26-13.98-13.98v-427.79c0-7.71,6.26-13.98,13.98-13.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m387.65,500.8h237.58c9.12,0,16.51-7.39,16.51-16.51s-7.39-16.51-16.51-16.51h-237.58c-9.12,0-16.51,7.39-16.51,16.51s7.39,16.51,16.51,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m387.65,435.38h237.58c9.12,0,16.51-7.39,16.51-16.51s-7.39-16.51-16.51-16.51h-237.58c-9.12,0-16.51,7.39-16.51,16.51s7.39,16.51,16.51,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m391.47,631.66h237.58c9.12,0,16.51-7.39,16.51-16.51s-7.39-16.51-16.51-16.51h-237.58c-9.12,0-16.51,7.39-16.51,16.51s7.39,16.51,16.51,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m391.47,566.23h237.58c9.12,0,16.51-7.39,16.51-16.51s-7.39-16.51-16.51-16.51h-237.58c-9.12,0-16.51,7.39-16.51,16.51s7.39,16.51,16.51,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m386.97,697.08h128.87c4.95,0,8.96-7.39,8.96-16.51s-4.01-16.51-8.96-16.51h-128.87c-4.95,0-8.96,7.39-8.96,16.51s4.01,16.51,8.96,16.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 614,
    cy: 725,
    r: 28
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m496.21,693.43c70.92.21,128.75-57.72,128.79-128.68.04-70.99-57.79-128.86-128.8-128.86-70.93,0-128.75,57.77-128.79,128.72-.04,70.99,57.79,129.02,128.8,128.82Zm-118.32-51.95c-10.7-16.63-17.62-34.63-20.79-54.15-.73.26-1.31.45-1.88.67-17.5,6.72-35.01,13.43-52.51,20.15-24.91,9.56-49.82,19.1-74.72,28.69-13.09,5.04-20.67,17.94-18.66,31.6,2.68,18.21,21.75,29.36,39.08,22.73,37.54-14.36,75.04-28.79,112.56-43.19,5.6-2.15,11.21-4.3,16.92-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m496.21,693.43c-71.01.21-128.83-57.83-128.8-128.82.04-70.96,57.86-128.72,128.79-128.72,71.01,0,128.83,57.87,128.8,128.86-.04,70.95-57.86,128.88-128.79,128.68Zm-101.06-128.8c-.01,55.83,45.08,101.05,100.82,101.11,56,.06,101.24-45.02,101.29-100.93.05-55.95-45.1-101.17-101.04-101.19-55.86-.02-101.06,45.15-101.08,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m377.89,641.48c-5.71,2.19-11.32,4.35-16.92,6.5-37.52,14.4-75.03,28.83-112.56,43.19-17.33,6.63-36.4-4.52-39.08-22.73-2.01-13.66,5.57-26.56,18.66-31.6,24.9-9.58,49.81-19.13,74.72-28.69,17.5-6.72,35.01-13.44,52.51-20.15.57-.22,1.15-.41,1.88-.67,3.17,19.52,10.09,37.52,20.79,54.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m395.15,564.63c.01-55.85,45.22-101.02,101.08-101,55.94.02,101.09,45.24,101.04,101.19-.05,55.91-45.3,100.99-101.29,100.93-55.74-.06-100.83-45.29-100.82-101.11Zm105.36-77.07c-13.09.03-21.87,1.55-30.38,4.62-.49.18-1.04.36-1.41.7-2.87,2.63-4.66,6.72-2.2,11.23,1.88,3.44,5.97,4.85,10.02,3.46,9.32-3.22,18.9-4.29,28.63-2.67,21.15,3.54,36.57,14.95,46.11,34.21.31.62.79,1.22,1.34,1.64,3.29,2.53,7.58,2.32,10.9-.47,2.85-2.39,3.71-6.65,1.85-10.15-14.7-27.55-38.03-41.17-64.86-42.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m500.51,487.56c26.82,1.4,50.16,15.02,64.86,42.57,1.86,3.49,1.01,7.75-1.85,10.15-3.32,2.79-7.62,2.99-10.9.47-.55-.42-1.03-1.02-1.34-1.64-9.55-19.26-24.97-30.67-46.11-34.21-9.72-1.63-19.3-.55-28.63,2.67-4.05,1.4-8.14-.01-10.02-3.46-2.46-4.5-.67-8.59,2.2-11.23.37-.34.92-.52,1.41-.7,8.51-3.07,17.29-4.59,30.38-4.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/Reports-Icon.640a849a12ab1b8bd9f7d6694ae4b3dd.svg";
export { ForwardRef as ReactComponent };